export default "__VITE_ASSET__418608a5__"